import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';
import UserDateFormat from '../../../components/user-date-format/index';

const ShipDateColumn = ({ fulfillmentId }) => {
  const { shipDateTime } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  if (!shipDateTime) {
    return '';
  }

  return <UserDateFormat value={shipDateTime} />;
};

ShipDateColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const ShipDate = {
  getMessageDescriptor: () => messages.shipDate,
  id: 'ship-date',

  render: (data) => {
    if (!data) {
      return '';
    }

    return <ShipDateColumn fulfillmentId={data.id} />;
  },
};
